import { all, call, fork, put, takeEvery } from 'redux-saga/effects'

import { GET_REPORT } from '../constants/ActionsTypes'
import { getReport as getReportApi } from '../api/Reports'
import { getReportSuccess, getReportError } from '../actions/Reports'

function* getReportRequest({ payload }) {
  try {
    const result = yield call(getReportApi, payload)
    yield put(getReportSuccess(result, payload?.reportId))
  } catch (error) {
    yield put(getReportError(error, payload?.reportId))
  }
}

export function* getReportSaga() {
  yield takeEvery(GET_REPORT, getReportRequest)
}

export default function* rootSaga() {
  yield all([fork(getReportSaga)])
}
